import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=14a906cc&scoped=true&"
import script from "./ServiceList.vue?vue&type=script&lang=ts&"
export * from "./ServiceList.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=14a906cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a906cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VChip,VContainer,VIcon,VTooltip})
